// extracted by mini-css-extract-plugin
module.exports = {"bannerLink":"banner_bannerLink__1b_cQ","banner":"banner_banner__3DXIi","start_button":"banner_start_button__1-AWo"};